import React from "react";
// import { makeStyles } from "@material-ui/core/styles";
import Input from "@material-ui/core/Input";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import ListItemText from "@material-ui/core/ListItemText";
import Select from "@material-ui/core/Select";
import Checkbox from "@material-ui/core/Checkbox";

// const useStyles = makeStyles((theme) => ({
//   formControl: {
//     margin: theme.spacing(1),
//     minWidth: 120,
//     maxWidth: 300,
//   },
//   chips: {
//     display: "flex",
//     flexWrap: "wrap",
//   },
//   chip: {
//     margin: 2,
//   },
//   noLabel: {
//     marginTop: theme.spacing(3),
//   },
// }));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function Selects({
  tags,
  setFinalSelected,
  master,
  finalSelected,
  addItem,
}) {
  const [selectedData, setSelectedData] = React.useState([]);

  const handleChange = (event) => {
    setSelectedData(event.target.value);
    // console.log('print',event.target.value)
    addItem(event.target.value, master);
  };
  // useEffect(() => {
  //   if (selectedData) {
  //     const allTags = tags
  //       .filter((tag) => tag.tagMaster.name === master)
  //       .map((e) => e._id);

  //       const filtered = selectedData.filter((e) => allTags.includes(e));
  //       console.log('test', filtered)
  //   }
  // }, [selectedData]);

  // const handleChangeMultiple = (event) => {
  //   const { options } = event.target;
  //   const value = [];
  //   for (let i = 0, l = options.length; i < l; i += 1) {
  //     if (options[i].selected) {
  //       value.push(options[i].value);
  //     }
  //   }
  //   setSelectedData(value);
  // };

  return (
    <div>
      <FormControl
        style={{
          marginLeft: 30,
          marginRight: 30,
          border: "2px solid #e45826",
          borderRadius: 50,
          width: 245,
        }}
      >
        <Select
          labelId="demo-mutiple-checkbox-label"
          id="demo-mutiple-checkbox"
          multiple
          value={selectedData}
          onChange={handleChange}
          input={<Input />}
          renderValue={(selected) => {
            console.log("selected data", selected);
            return tags
              .filter((tag) => selected.includes(tag._id))
              .map((e) => e.name)
              .join(", ");
          }}
          MenuProps={MenuProps}
          style={{
            marginLeft: 10,
            lineHeight: 1.5,
            borderColor: "#e45826",
            borderRadius: 60,
            borderWidth: 1,
            width: 225,
          }}
        >
          {/* <MenuItem value="" disabled>
            {tags
              .filter((tag) => tag.tagMaster.name === master)
              .map((tag) => tag.name)}
            .join(", ");
          </MenuItem> */}
          {tags
            .filter((tag) => tag.tagMaster.name === master)
            .map((tag) => (
              <MenuItem key={tag._id} value={tag._id}>
                <Checkbox
                  style={{
                    color: "#e45826",
                  }}
                  checked={selectedData.indexOf(tag._id) > -1}
                />
                <ListItemText primary={tag.name} />
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </div>
  );
}
